/*** IMPORTS FROM imports-loader ***/
(function() {
var app = window.app||{};
var define = false;
var exports = false;
var module = undefined;

var app = app || {};

(function ($) {
  'use strict';

  /**
   * Вид формы заказа заявки
   */
  app.CallMeView = app.CallMeFormView.extend({
    el: '.callme-form',
    formName: 'callme-form',
    initiatorSelector: 'dl',
    managerId: null,

    save: function () {
      var model = this.modelName,
        attributes = {},
        that = this;
      this.model = new app[model](null, {
        requestParameters: {
          // определяем параметр запроса для проверки согласия на обработку данных если задана соответствующая опция
          features: this.checkAgreement ? 'accept_agreement' : null,
        },
      });
      if (this.managerId) {
        this.model.set({manager_id: this.managerId});
      }
      this.$fields.each(function () {
        if (this.name !== null) {
          if (this.name === 'settlement_id') {
            attributes[this.name] = that.$('.callme-city').data('city-id');
          } else if ($(this).attr('type') === 'checkbox') {
            attributes[this.name] = $(this).prop('checked');
          } else {
            attributes[this.name] = $(this).val();
          }
        }
      });
      this.model.on('sync', this.success, this);
      this.model.on('error', this.error, this);
      this.model.save(attributes);
    },

    beforeRun: function () {
      app.CallMeFormView.prototype.beforeRun.apply(this, arguments);
      var settlementAutocomplete = new app.SettlementAutocompleteView({'el': this.$('.callme-city')});
      settlementAutocomplete.on('autocompleteDone', this.saveCity);
      this.managerId = this.$el.data('manager_id');
    },

    saveCity: function (id) {
      this.$el.data('city-id', id);
    },

    fillErrors: function (errors) {
      var that = this;

      errors.forEach(function (error) {
        that.$('.' + that.formName + '-' + error.field + '-error').text(error.message);
        that.$('.' + that.formName + '-' + error.field).addClass('error');
      });
    },

    successAfter: function () {
      app.CallMeFormView.prototype.successAfter.apply(this, arguments);
      this.$(this.formElement).val('');
    }
  });
})(jQuery);

}.call(window));